export const comments_3296178 = {"data":{"data":[],"links":{}}}